import { combineReducers } from 'redux';
import { persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";
import storageSession from 'redux-persist/lib/storage/session';

import userStore from './userStore';
import videoListStore from './videoListStore';
import audioListStore from './audioListStore';
import bookListStore from './bookListStore';


const rootReducer = combineReducers({
	userStore,
	videoListStore,
	audioListStore,
	bookListStore
});

const persistConfig = {
	key: "root",
	storage: storageSession,
	whitelist: ["userStore", "videoListStore", "audioListStore", "bookListStore"],
};

//export default rootReducer;
export default persistReducer(persistConfig, rootReducer);

